export default __webpack_public_path__ + "8bbb0d324cd9eea982672e8f5ab28750.png";